// href <-> (type, value) for the editor's link modal (LinkPromptModal.vue).
//
// Types: 'website' -> https://…, 'email' -> mailto:…, 'phone' -> tel:… (fax too).
// Values may be placeholders ([userE], [userT]) — the client / the e-mail
// replace them with the travel expert's data, inside the href as well.
//
// Until 1.0.5 the link tool forced `https://` onto everything, so an e-mail
// link became `https://mailto:…`, which the browser reads as user "mailto:…"
// AT host "<domain after the @>" and opened the agency website instead of the
// mail client (Explorer, 2026-10-27).

export const LINK_TYPES = ['website', 'email', 'phone'];

/**
 * @param {'website'|'email'|'phone'} type
 * @param {string} value what the user typed (scheme optional)
 * @returns {string|null} href, or null when the value is empty
 */
export function buildLinkHref(type, value) {
  const v = String(value === null || value === undefined ? '' : value).trim();
  if (!v) return null;
  switch (type) {
    case 'email':
      return `mailto:${v.replace(/^mailto:/i, '')}`;
    case 'phone':
      // keep the digits readable; browsers accept spaces/brackets in tel:
      return `tel:${v.replace(/^tel:/i, '')}`;
    default:
      return /^https?:\/\//i.test(v) ? v : `https://${v}`;
  }
}

/**
 * Inverse of buildLinkHref, for pre-filling the modal on an existing link.
 * @param {string|null} href
 * @returns {{ type: 'website'|'email'|'phone', value: string }}
 */
export function parseLinkHref(href) {
  const h = String(href || '').trim();
  if (/^mailto:/i.test(h)) return { type: 'email', value: h.replace(/^mailto:/i, '') };
  if (/^tel:/i.test(h)) return { type: 'phone', value: h.replace(/^tel:/i, '') };
  return { type: 'website', value: h };
}
